import { UPLOAD_STATUS } from "./upload/DocumentUpload";

export const initializePdfFormStateObject = (
  pdfFormUrl,
  pdfFormName,
  fieldDefinitions,
  scale = 1.5
) => {
  return {
    url: pdfFormUrl,
    name: pdfFormName,
    scale: scale,
    validationErrors: {},
    currentFieldValues: {},
    fieldDefinitions: fieldDefinitions || {},
    annotationLayer: {
      loaded: false,
      annotations: {},
    },
  };
};

export const init = (payload) => {
  return { ...payload };
};

export const annotations = (state, action) => {
  if (action.type === "annotations") {
    action.payload.annotations.forEach((annotation) => {
      state.pdfForm.annotationLayer.annotations[annotation.id] = {
        name: annotation.fieldName,
        value: annotation.fieldValue,
        exportValue: annotation.radioButton ? annotation.buttonValue : annotation.exportValue,
        type: annotation.fieldType,
        pageIndex: action.payload.pageIndex,
        checkBox: annotation.checkBox,
        radioButton: annotation.radioButton,
      };
    });
    state.pdfForm.annotationLayer.annotations = {
      ...state.pdfForm.annotationLayer.annotations,
    };
    state.pdfForm.annotationLayer.loaded = action.payload.annotationsLoaded;
    return { ...state };
  }
};

export const pdfFieldFormValidation = (state, action) => {
  if (action.type === "pdf-field-validation") {
    let payload = action.payload;
    let { id, name, value, valid, exportValue, type, checkBox } = payload;

    state.pdfForm.currentFieldValues[name] = {
      value,
      valid,
      exportValue,
      id,
      type,
      checkBox,
    };

    if (payload.type === "Btn" && payload.checkBox) {
      if (payload.value === "false") {
        delete state.pdfForm.currentFieldValues[name];
      }
    }

    if (!payload.valid) {
      state.pdfForm.validationErrors[name] = {
        fieldDefinition: payload.fieldDefinition,
        id: payload.id,
      };
    } else {
      delete state.pdfForm.validationErrors[name];
    }
    return {
      ...state,
      pdfForm: {
        ...state.pdfForm,
        validationErrors: { ...state.pdfForm.validationErrors },
        currentFieldValues: { ...state.pdfForm.currentFieldValues },
      },
    };
  }
};

export const pdfFormValidation = (state, action) => {
  if (action.type === "pdf-form-validation") {
    action.payload.forEach((validationError) => {
      let { id, name, fieldDefinition } = validationError;
      state.pdfForm.validationErrors[name] = {
        fieldDefinition,
        id,
      };
    });
    return {
      ...state,
      pdfForm: {
        ...state.pdfForm,
        validationErrors: { ...state.pdfForm.validationErrors },
      },
    };
  }
};

export const pdfFormDefaultValues = (state, action) => {
  if (action.type === "default-values") {
    const payload = Object.entries(action.payload);
    payload.forEach((payload) => {
      if (payload[1].defaultValue !== null) {
        let defaultValue = payload[1].defaultValue;
        state.pdfForm.currentFieldValues[payload[0]] = {
          value: defaultValue,
        };
      }
    });
  }
};

export const pdfFormReducerActions = (state, action) => {
  return (
    annotations(state, action) ||
    pdfFieldFormValidation(state, action) ||
    pdfFormValidation(state, action) ||
    pdfFormDefaultValues(state, action)
  );
};

export const reducer = (state, action) => {
  switch (action.type) {
    case "next":
      return { ...state, activeStepIndex: state.activeStepIndex + 1 };
    case "previous":
      return {
        ...state,
        activeStepIndex: state.activeStepIndex - (action.n || 1),
      };
    case "init":
      if (!action.payload) {
        return { ...state };
      }

      let {
        uid,
        isBlocking,
        newReq,
        href,
        pdfFormUrl,
        pdfFormName,
        infos,
        paymentAndDelivery,
        fieldDefinitions,
        requiredDocuments,
        uploadConstraints,
        review,
        organizationUnitId,
        organizationUnits,
      } = action.payload;

      state.uid = uid;

      state.href = null;

      state.organizationUnitId = null;
      state.organizationUnits = [...organizationUnits];

      state.newReq = true;
      state.isBlocking = true;

      state.pdfForm = {
        ...state.pdfForm,
        name: pdfFormName,
        url: pdfFormUrl,
        fieldDefinitions,
      };
      state.info = { messages: infos };
      state.paymentAndDelivery = { enabled: paymentAndDelivery };

      let documents = requiredDocuments.map((requiredDocument) => {
        return {
          ...requiredDocument,
          uploadError: null,
          uploadProgress: 0,
          uploadStatus: UPLOAD_STATUS.NOT_STARTED,
          file: null,
          href: null,
          required: true,
        };
      });

      state.upload = {
        uploadConstraints,
        documents,
      };

      let consents = review.consents.map((consent) => {
        return { ...consent, accepted: false };
      });

      state.review = { ...review, consents };

      return { ...state };
    case "load":
      if (!action.payload) {
        return { ...state };
      }
      action.payload.newReq = false;
      action.payload.isBlocking = true;
      return { ...action.payload };
    case "save":
      return state;
    case "discard":
      return state;
    case "update-documents":
      return {
        ...state,
        upload: { ...state.upload, documents: [...state.upload.documents] },
      };
    case "update-consents":
      return {
        ...state,
        review: { ...state.review, consents: [...state.review.consents] },
      };

    case "block":
      state.isBlocking = true;
      return { ...state };

    case "sign":
      state.href = action.payload;
      return { ...state };

    case "unblock":
      state.isBlocking = false;
      state.newReq = false;
      return { ...state };

    case "setOrgUnitId":
      state.organizationUnitId = action.payload;
      return { ...state };

    default:
      return pdfFormReducerActions(state, action) || state;
  }
};
